import { AccessGroup } from "./accessGroup";
import { randomColor } from "../helpers/color";

export const CONSTANTS = {
	SIX_MONTHS: "6",
	TWELVE_MONTHS: "12"
};

export default class Zone extends AccessGroup {
	constructor({
		id,
		name,
		color,
		rules,
		accessGroupRightCount = null,
		stats = null,
		periods = null,
		populations = null,
		checkpoints = null
	} = {}) {
		super({ id, name, rules, accessGroupRightCount, stats });

		this.color = color || randomColor();
		this.periods = periods || [];
		this.populations = populations || [];
		this.checkpoints = checkpoints || [];
	}

	static buildFromJSON(json) {
		return new Zone({
			...super.buildFromJSON(json),
			color: json.color,
			periods: json.periods ?? null,
			populations: json.populations ?? null,
			checkpoints: json.checkpoints ?? null
		});
	}

	toJSON() {
		return {
			...super.toJSON(),
			color: this.color
		};
	}

	getId() {
		return this.id;
	}

	getColor() {
		return this.color;
	}

	getName() {
		return this.name;
	}
}
